import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import RegisterDialog from "./RegisterDialog.vue";
import { handleSSOLogin } from "@/utils/sso-login";
// 提交代码前需撤销注释
import { getStoreToken, clearToken, setStoreUserObj, getStoreUserObj } from "../utils/token";
import { getEventUserInfo } from "@/api/user";
import { getEventList, getEventSchedule, getEventId } from "@/api/event";
import menuIcon from "@/assets/img/menu.png";
import applyIcon from "@/assets/img/apply.png";
import certificateIcon from "@/assets/img/cer.png";
export default {
  name: "ACtivity",
  components: {
    RegisterDialog
  },
  mixins: [],
  props: {},
  data() {
    return {
      show: false,
      iframeUrl: "",
      activeId: 0,
      current: {},
      userInfo: {},
      menubar: [],
      eventId: "",
      eventName: "",
      eventList: [],
      eventSchedule: [],
      cmsId: this.$route.query.cmsId || 10111,
      userSubmitFlag: ""
    };
  },
  computed: {},
  watch: {},
  created() {
    // 提交代码前需撤销注释
    if (!getStoreToken()) {
      handleSSOLogin();
    } else {
      this.show = true;
      // this.getEventList();
      this.getEventId();
    }
  },
  mounted() {},
  methods: {
    async getEventUserInfo() {
      let res = await getEventUserInfo(this.eventId);
      if (res.code == 200) {
        this.userInfo = res.data;
        if (this.userInfo.userName) {
          setStoreUserObj({
            ...this.userInfo,
            eventId: this.eventId
          });
        } else {
          setStoreUserObj({
            ...getStoreUserObj(),
            eventId: this.eventId
          });
        }
        this.getEventSchedule();
        if (!this.userInfo.schoolId && this.$route.path != "/personalInfo") {
          this.showRegisterDialog();
        }
      }
    },
    async getEventList() {
      let res = await getEventList();
      if (res.code == 200) {
        this.eventList = res.data;
        if (this.eventList.length > 0) {
          this.eventId = this.eventList[0].id;
          this.getEventUserInfo();
        }
      } else if (res.code == 401) {
        clearToken();
        handleSSOLogin();
      }
    },
    async getEventId() {
      let res = await getEventId(this.cmsId);
      if (res.code == 200) {
        this.eventId = res.data.id;
        this.eventName = res.data.eventName;
        this.getEventUserInfo();
      } else if (res.code == 401) {
        clearToken();
        handleSSOLogin();
      }
    },
    handleEventChange() {
      this.getEventUserInfo();
    },
    async getEventSchedule() {
      let res = await getEventSchedule(this.eventId, 1);
      this.menubar = [];
      if (this.userInfo.leaderFlag == 1) {
        this.menubar.push({
          title: "参赛选手总览",
          path: "/overview?eventId=" + this.eventId + "&cmsId=" + this.cmsId,
          id: 2,
          show: true,
          icon: menuIcon,
          isLeader: true
        });
      }
      if (res.code == 200) {
        var _res$data$scheduleLis, _res$data;
        this.eventSchedule = (_res$data$scheduleLis = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.scheduleList) !== null && _res$data$scheduleLis !== void 0 ? _res$data$scheduleLis : [];
        this.eventSchedule.forEach(item => {
          let startTime = new Date(item.startTime).getTime();
          let endTime = new Date(item.endTime).getTime();
          if (item.linkedAuditStatus == 0) {
            item.n = 3; //审核未通过
          }
          if (item.linkedAuditStatus == 2) {
            item.n = 4;
          }
          if (res.time < startTime) {
            item.n = 1; //未开始
          } else if (res.time > endTime) {
            item.n = 2; //已结束
          }
          this.menubar.push({
            title: item.scheduleName,
            path: "/activity?eventId=" + this.eventId + "&scheduleId=" + item.id + "&scheduleType=" + item.scheduleType + "&scheduleName=" + encodeURIComponent(item.scheduleName) + "&userSubmitFlag=" + item.userSubmitFlag + "&cmsId=" + this.cmsId + "&joinFlag=" + item.joinFlag + "&n=" + item.n + "&isAudit=" + item.isAudit,
            id: item.id,
            show: true,
            icon: process.env.VUE_APP_FILE_URL + item.scheduleImg
          });
        });
        console.log("菜单数据====", this.menubar);
        this.menubar.push({
          title: "电子证书查看",
          path: "/certificate?eventId=" + this.eventId + "&eventName=" + encodeURIComponent(this.eventName) + "&cmsId=" + this.cmsId,
          id: 1,
          show: true,
          icon: certificateIcon
        });
        if (this.userInfo.leaderFlag != 1) {
          this.menubar.push({
            title: "院校领队申报",
            path: "/leaderApply?eventId=" + this.eventId + "&cmsId=" + this.cmsId,
            id: 3,
            show: true,
            icon: applyIcon,
            isApply: true
          });
        }
        this.menubar.push({
          title: "个人信息",
          path: "/personalInfo?cmsId=" + this.cmsId,
          id: 4,
          show: false
        });
        // 默认选中的菜单：根据当前url判断
        if (this.$route.path == "/activity" && this.$route.query.scheduleId || this.$route.path != "/activity") {
          this.current = this.menubar.find(item => item.path === this.$route.fullPath);
        }
        console.log(1111, this.current, this.menubar);
        if (!this.current || this.current && !this.current.id) {
          const index = this.eventSchedule.findIndex(item => item.isLocation == 1);
          if (index == -1 || this.userInfo.leaderFlag == 1) {
            this.current = this.menubar[0];
          } else {
            this.current = this.menubar[index];
          }
          this.$router.push(this.current.path);
        }
      }
    },
    adjustIframeHeight() {
      const iframe = this.$refs.activityIframe;
      if (iframe) {
        const contentWindow = iframe.contentWindow;
        const contentDocument = contentWindow.document;
        const height = Math.max(contentDocument.body.scrollHeight, contentDocument.documentElement.scrollHeight, contentDocument.body.offsetHeight, contentDocument.documentElement.offsetHeight, contentDocument.body.clientHeight, contentDocument.documentElement.clientHeight);
        iframe.style.height = `${Math.max(height, 1000)}px`;
      }
    },
    handleSSOLogin() {
      handleSSOLogin();
    },
    showRegisterDialog() {
      this.$refs.registerDialog.show({
        ...this.userInfo,
        eventId: this.eventId
      });
    },
    async hanldeMenuClick(item) {
      if (!this.userInfo.schoolId) {
        this.$message.warning("请先绑定所属院校");
        return;
      }
      let res = await getEventSchedule(this.eventId, 1);
      if (res.code == 200) {
        var _res$data$scheduleLis2, _res$data2;
        let schedule = (_res$data$scheduleLis2 = (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.scheduleList) !== null && _res$data$scheduleLis2 !== void 0 ? _res$data$scheduleLis2 : [];
        schedule.forEach(i => {
          if (item.id == i.id) {
            this.userSubmitFlag = i.userSubmitFlag;
          }
        });
        // let time = res.time;
        // let schedule = res.data?.scheduleList ?? [];
        // var n = 0;
        // schedule.forEach((i) => {
        //   if (item.id == i.id) {
        //     let startTime = new Date(i.startTime).getTime();
        //     let endTime = new Date(i.endTime).getTime();
        //     if (i.linkedAuditStatus == 0) {
        //       n = 3;
        //     }
        //     if (time < startTime) {
        //       n = 1;
        //     } else if (time > endTime) {
        //       n = 2;
        //     }
        //   }
        // });
      } else if (res.code == 401) {
        clearToken();
        handleSSOLogin();
      }
      // if (n == 3) {
      //   this.$message.warning("很遗憾，您未入围现场评审，感谢您的支持！");
      //   // return;
      // }
      // if (n == 1) {
      //   this.$message.warning("活动未开始");
      //   // return;
      // } else if (n == 2) {
      //   this.$message.warning("活动已结束");
      //   // return;
      // }
      this.current = item;
      this.pageTitle = item.title;
      this.$router.push(item.path);
      this.$nextTick(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      });
    },
    async refresh() {
      let res = await getEventSchedule(this.eventId, 1);
      this.menubar = [];
      if (this.userInfo.leaderFlag == 1) {
        this.menubar.push({
          title: "参赛选手总览",
          path: "/overview?eventId=" + this.eventId + "&cmsId=" + this.cmsId,
          id: 2,
          show: true,
          icon: menuIcon,
          isLeader: true
        });
      }
      if (res.code == 200) {
        var _res$data$scheduleLis3, _res$data3;
        this.eventSchedule = (_res$data$scheduleLis3 = (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.scheduleList) !== null && _res$data$scheduleLis3 !== void 0 ? _res$data$scheduleLis3 : [];
        this.eventSchedule.forEach(item => {
          let startTime = new Date(item.startTime).getTime();
          let endTime = new Date(item.endTime).getTime();
          if (item.linkedAuditStatus == 0) {
            item.n = 3; //审核未通过
          }
          if (item.linkedAuditStatus == 2) {
            item.n = 4;
          }
          if (res.time < startTime) {
            item.n = 1; //未开始
          } else if (res.time > endTime) {
            item.n = 2; //已结束
          }
          this.menubar.push({
            title: item.scheduleName,
            path: "/activity?eventId=" + this.eventId + "&scheduleId=" + item.id + "&scheduleType=" + item.scheduleType + "&scheduleName=" + encodeURIComponent(item.scheduleName) + "&userSubmitFlag=" + item.userSubmitFlag + "&cmsId=" + this.cmsId + "&joinFlag=" + item.joinFlag + "&n=" + item.n + "&isAudit=" + item.isAudit,
            id: item.id,
            show: true,
            icon: process.env.VUE_APP_FILE_URL + item.scheduleImg
          });
        });
        this.menubar.push({
          title: "电子证书查看",
          path: "/certificate?eventId=" + this.eventId + "&eventName=" + encodeURIComponent(this.eventName) + "&cmsId=" + this.cmsId,
          id: 1,
          show: true,
          icon: certificateIcon
        });
        if (this.userInfo.leaderFlag != 1) {
          this.menubar.push({
            title: "院校领队申报",
            path: "/leaderApply?eventId=" + this.eventId + "&cmsId=" + this.cmsId,
            id: 3,
            show: true,
            icon: applyIcon
          });
        }
        this.menubar.push({
          title: "个人信息",
          path: "/personalInfo?cmsId=" + this.cmsId,
          id: 4,
          show: false
        });
      }
    },
    updateUserInfo(userInfo) {
      this.userInfo = {
        ...this.userInfo,
        ...userInfo
      };
      this.getEventUserInfo();
      console.log(1111, this.userInfo);
      // if (this.eventSchedule.length == 0 && this.userInfo.leaderFlag != 1) {
      //   this.current = this.menubar.length > 1 ? this.menubar[1] : this.menubar[0];
      //   this.$router.push(this.current.path);
      //   this.$message.warning("活动日程尚未开启/已结束，请稍后再试");
      // }else if(this.eventSchedule.length == 0 && this.userInfo.leaderFlag == 1){
      //   this.$message.warning("活动日程尚未开启/已结束，请稍后再试");
      // }
    },
    handleNoticeClick() {
      if (process.env.VUE_APP_FILE_UPDATE_NOTICE_URL) {
        window.open(process.env.VUE_APP_FILE_UPDATE_NOTICE_URL, "_blank");
      }
    }
  }
};